import moment from 'moment';

export function setCookie(cname, cvalue, expires_in) {
  let d = new Date();
  let expires = '';

  if (expires) {
    d.setTime(d.getTime() + expires);
    expires = 'expires=' + d.toUTCString();
  }
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function setCookieWithExpiration(cname, cvalue) {
  // Calculate the expiration time (4 hours from now)
  const expiration = new Date();
  expiration.setTime(expiration.getTime() + 12 * 60 * 60 * 1000); // 4 hours in milliseconds

  // Format the expiration date in the proper format for cookies
  const expires = 'expires=' + expiration.toUTCString();

  // Set the cookie with the specified expiration time and path
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function getCookie(name) {
  let value = '; ' + document.cookie;
  let parts = value.split('; ' + name + '=');
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export function deleteCookie(name) {
  setCookie(name, '', -1);
}

export function formatPhoneNumber(phoneNumberString) {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    let intlCode = match[1] ? '+1 ' : '';
    return [
      // intlCode,
      '(',
      match[2],
      ')',
      ' ',
      match[3],
      '-',
      match[4],
      ''
    ].join('');
  }
  return null;
}

export const formatNumberOntype = number => {
  const x = number.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  if (x.length <= 10) {
    return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
  }
};

export const DateStrip = Value => {
  const dateNow = new Date(Value);
  const year = dateNow.getFullYear();
  const monthWithOffset = dateNow.getUTCMonth() + 1;
  const month =
    monthWithOffset.toString().length < 2
      ? `0${monthWithOffset}`
      : monthWithOffset;
  const date =
    dateNow.getUTCDate().toString().length < 2
      ? `0${dateNow.getUTCDate()}`
      : dateNow.getUTCDate();
  return `${year}-${month}-${date}`;
};

export const getDate = (date, isReverse = false) => {
  const d = new Date(date);

  let month = ('0' + (d.getMonth() + 1)).slice(-2);
  let day = ('0' + d.getDate()).slice(-2);
  let year = d.getFullYear();
  if (isReverse) {
    return `${year}-${month}-${day}`;
  }
  return `${month}-${day}-${year}`;
};
export const MONTHS_LIST_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

export const getDateWithoutYear = (date, isReverse = false) => {
  const d = new Date(date);
  let month = d.getMonth();
  let day = ('0' + d.getDate()).slice(-2);
  let year = d.getFullYear();
  if (isReverse) {
    return `${year}-${month}-${day}`;
  }
  return `${day}-${MONTHS_LIST_SHORT[month]}`;
};
export const MONTHS_LIST = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const DAYS_LIST = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

export const ROLES = {
  SUPER_ADMIN: 'SUPER ADMIN',
  CLIENT_ADMIN: 'CLIENT ADMIN',
  CLIENT_USER: 'CLIENT USER',
  AGENT: 'AGENT',
  MANAGER: 'MANAGER',
  ADMIN: 'ADMIN',
  TESTER: 'TESTER'
};

export const parseTokensLowerCase = (inputString, delimiter) => {
  const tokens = inputString.split(delimiter);
  return tokens
    .map(token => token.toLowerCase().trim())
    .filter(token => token.length > 0);
};
